var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iw-input-checkbox-group',{attrs:{"checkboxes":_vm.checkboxes,"input-label":"","name":("terms-agreement-" + _vm.uniqueId),"values-checked":_vm.valueChecked,"required":true,"input-optional":false},on:{"update-value":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }